//libs
import dynamic from 'next/dynamic';

// Styles
import { ButtonsContainer, HeaderWrap, LogoContainer, MaxWidth } from './style';

import Cookies from 'js-cookie';

// Components
import { MainLogo } from './components/MainLogo';
import { Search } from './components/RoundButtons/components/Search';
import { useEffect, useState } from 'react';

// Hooks
import { useGetAccessToken } from 'api/auth/useGetAccessToken';
import useLangLinks from 'modules/main/hooks/useLangLinks';
import { useHeader } from './hooks/useHeader';
import { useCookies } from 'react-cookie';

const RoundButtons = dynamic(
  () => import('modules/main/layouts/Header/components/RoundButtons'),
  {
    ssr: false,
  }
);

const LangSwitch = dynamic(
  () => import('modules/main/layouts/Header/components/TopMenu/LangSwich'),
  {
    ssr: false,
  }
);

const BurgerMenu = dynamic(
  () => import('modules/main/layouts/Header/components/BurgerMenu'),
  {
    ssr: false,
  }
);

const SiteMenu = dynamic(
  () => import('modules/main/layouts/Header/components/SiteMenu'),
  {
    ssr: false,
  }
);

const TopMenu = dynamic(() => import('modules/main/layouts/Header/components/TopMenu'), {
  ssr: false,
});

export const Header = props => {
  const { isResetPassword, isArticle, dataForHeader = {} } = props;

  const [{ _identity } = {}] = useCookies(['_identity']);

  const { checkAuth, checkToken, auth_key, node, isMenuOpen, setMenuOpen, deviceWidth } =
    useHeader({
      _identity,
    });

  useLangLinks(dataForHeader.articleMetaData);
  // @ts-ignore

  useEffect(() => {
    const cookieValue = Cookies.get('_identity');
    checkAuth(cookieValue);
  }, [_identity]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const cookieValue = Cookies.get('_identity');

      if (!document.hidden) {
        checkAuth(cookieValue);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    checkToken(auth_key);
  }, [auth_key]);

  const { logo = '' } = dataForHeader;

  return (
    <HeaderWrap ref={node} open={isMenuOpen}>
      <TopMenu
        isArticle={isArticle}
        isResetPassword={isResetPassword}
        dataForHeader={dataForHeader}
        deviceWidth={deviceWidth}
        isColumnist={props.isColumnist}
      />
      {!isResetPassword && (
        <>
          <MaxWidth>
            {deviceWidth <= 768 && isMenuOpen && (
              <LangSwitch
                isArticle={isArticle}
                isColumnist={props.isColumnist}
                dataForHeader={dataForHeader}
              />
            )}
            <span></span>
            <SiteMenu setMenuOpen={setMenuOpen} isMenuOpen={isMenuOpen} />
            <ButtonsContainer>
              {deviceWidth >= 1024 && <Search />}
              {deviceWidth <= 768 && isMenuOpen && <RoundButtons />}
              {deviceWidth > 768 && <RoundButtons />}
            </ButtonsContainer>
          </MaxWidth>
          <LogoContainer>
            <MainLogo logo={logo} />
          </LogoContainer>
          {deviceWidth <= 1024 && (
            <BurgerMenu node={node} isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
          )}
          {deviceWidth <= 1024 && <Search />}
        </>
      )}
    </HeaderWrap>
  );
};
